import { render, staticRenderFns } from "./deliveryTabMtpt.vue?vue&type=template&id=10fd21b2&scoped=true"
import script from "./deliveryTabMtpt.vue?vue&type=script&lang=js"
export * from "./deliveryTabMtpt.vue?vue&type=script&lang=js"
import style0 from "./deliveryTabMtpt.vue?vue&type=style&index=0&id=10fd21b2&lang=scss"
import style1 from "./deliveryTabMtpt.vue?vue&type=style&index=1&id=10fd21b2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fd21b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\space\\tops\\tops-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10fd21b2')) {
      api.createRecord('10fd21b2', component.options)
    } else {
      api.reload('10fd21b2', component.options)
    }
    module.hot.accept("./deliveryTabMtpt.vue?vue&type=template&id=10fd21b2&scoped=true", function () {
      api.rerender('10fd21b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/dialog/deliveryTab/deliveryTabMtpt.vue"
export default component.exports